<template>
  <div>
    <div
      v-for="item in filteredItems"
      :key="`${query}/${item.id}/${item.level}`"
      :class="`level${query ? '1' : item.level}`"
      class="item"
    >
      <span
        class="name"
        v-bind:class="{ changed: item.modifiedCount }"
        @click="toggle(item.id)"
      >
        <b-icon
          :icon="expanded.indexOf(item.id) === -1 ? 'folder' : 'folder-open'"
          :class="`level${query ? '1' : item.level}`"
          pack="fas"
          size="is-small"
        />
        {{ item.name }}
        <template v-if="item.documentsTotal > 0">
          <span v-text="item.documentsTotal" class="tag is-rounded is-small" />
          <span
            v-if="item.documentsTotal - item.documentsReadCount > 0"
            v-text="item.documentsTotal - item.documentsReadCount"
            class="tag is-rounded is-primary"
          />
        </template>
      </span>
      <div v-show="expanded.indexOf(item.id) !== -1">
        <PortefeuilleArboDocs
          v-if="item.documents.length > 0"
          :id="item.id"
          :level="item.level"
          :documents="item.documents"
        />
        <PortefeuilleArboCollections
          v-if="item.collections.length > 0"
          :id="item.id"
          :level="item.level"
          :collections="item.collections"
        />
        <PortefeuilleArbo
          v-if="!query"
          ref="arbo"
          :items="items"
          :level="item.level + 1"
          :parent="item.id"
          :query="query"
          :showUnreadOnly="showUnread"
        />
        <div
          v-if="(query || !item.hasSubfolders) && item.documents.length === 0 && item.collections.length === 0"
          class="empty"
        >
          Ce dossier est vide
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PortefeuilleArboCollections from '@/components/Portefeuille/ArboCollections'
import PortefeuilleArboDocs from '@/components/Portefeuille/ArboDocs'

import MixinDocumentHelper from '@/mixins/DocumentHelper'

export default {
  mixins: [MixinDocumentHelper],
  name: 'PortefeuilleArbo',
  components: {
    PortefeuilleArboCollections,
    PortefeuilleArboDocs,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    parent: {
      type: Number,
      default: () => 0,
    },
    level: {
      type: Number,
      default: () => 1,
    },
    query: {
      type: String,
      default: () => '',
    },
    showUnreadOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expanded: [],
      showUnread: false
    }
  },
  watch: {
    expanded: {
      handler: function (newValue) {
        this.retrieveArboDetails(newValue)
      },
      deep: true,
    },
    query: {
      handler: function (newValue) {
        if (newValue && newValue.length > 0) {
          this.retrieveArboDetails(this.items.map((item) => item.id))
        }
      },
      deep: true,
    }
  },
  computed: {
    filteredItems () {
      let filteredItems = [...this.items]
      if (!this.query) {
        filteredItems = filteredItems.filter((item) => {
          if (this.parent === 0) {
            return item.level === 1
          } else {
            return item.parent === this.parent && item.level === this.level
          }
        })
      }
      return filteredItems
    },
  },
  methods: {
    toggle (id) {
      const index = this.expanded.indexOf(id)
      if (index === -1) {
        this.expanded.push(id)
      } else {
        this.expanded.splice(index, 1)
      }
    },
    toggleAll (expand) {
      if (expand) {
        this.expanded = this.items.map((i) => i.id)
      } else {
        this.expanded = []
      }
      if (this.$refs.arbo) {
        this.$refs.arbo.forEach((i) => i.toggleAll(expand))
      }
    },
    retrieveArboDetails (newValue) {
      newValue.forEach((id) => {
        const item = this.items.find((i) => i.id === id)
        if (
          item &&
          item.details === undefined &&
          (item.documents.length > 0 || item.collections.length > 0)
        ) {
          try {
            item.details = false
            this.$store.dispatch('inv/getArboDetails', {
              bienID: this.$route.params.bien,
              arboLevel: item.level,
              arboID: item.id,
            })
          } catch (e) {
            this.apiError(e)
          }
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.item {
  padding: 0.2em 0;
}
.changed {
  color: #35a0d0;
  font-weight: bold;
}
.icon.level1 {
  color: #8d8d8d;
}
.icon.level2 {
  color: #9f84d3;
}
.icon.level3 {
  color: #35a0d0;
}
.icon.level4 {
  color: #53b069;
}
.icon.level5 {
  color: #dd8b51;
}
.level2,
.level3,
.level4,
.level5,
.level6,
.level7,
.level8,
.level9 {
  padding-left: 0.5em;
}
.name {
  cursor: pointer;
  font-size: 0.9em;
  font-weight: bold;
  &:hover {
    color: #ed9e1a;
  }
}
.icon {
  margin-right: 0.15em;
}
span.tag {
  font-size: 0.6em;
  position: relative;
  top: -0.2em;
  margin-left: 0.5em;
}
.empty {
  color: #666;
  font-size: 0.85em;
  font-style: italic;
  padding: 0.25em 0 0.5em 2em;
}
</style>
